import Vue from "vue";
import VueRoter from "vue-router";
import App from "./App.vue";
import "./style/vendor.css"
import "./style/theme.css"
import SearchIndex from "./view/searchIndex.vue";
// import Modal from "./view/modal.vue";
import indexModal from "./view/indexModal.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
// import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min'
import { Message } from "element-ui";
window.$Message = Message;

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });
Vue.use(VueRoter);

const routes = [
  { path: "/", redirect: "/search", component: SearchIndex },
  // { path: "/modal", component: Modal },
  // { path: "/indexmodal", component: indexModal },
  { path: "/search", component: indexModal },
  { path: "*", redirect: "/" },
];

const router = new VueRoter({
  // mode: 'history',
  routes,
});

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
